import { cn } from '@lib/utils';

const COLOR_GRADIENTS = [
  {
    stroke: '#BEC2CC',
    from: 'from-[#BEC2CC]',
    to: 'to-[#BABEC8]',
  },
  {
    stroke: '#BABEC8',
    from: 'from-[#BABEC8]',
    to: 'to-[#9B9FA7]',
  },
  {
    stroke: '#9B9FA7',
    from: 'from-[#9B9FA7]',
    to: 'to-[#7C7F86]',
  },
  {
    stroke: '#7C7F86',
    from: 'from-[#7C7F86]',
    to: 'to-[#5E6066]',
  },
  {
    stroke: '#5E6066',
    from: 'from-[#5E6066]',
    to: 'to-[#47494E]',
  },
  {
    stroke: '#47494E',
    from: 'from-[#47494E]',
    to: 'to-[#47494E]',
  },
];

interface StepperProps {
  labels: React.ReactNode[];
}

function Stepper({ labels }: StepperProps) {
  return (
    <ul className="flex flex-col">
      {labels.map((label, idx) => (
        <li key={idx * 1} className="relative flex gap-x-4 md:gap-x-6">
          {idx < labels.length - 1 && (
            <StepLine
              from={COLOR_GRADIENTS[idx].from}
              to={COLOR_GRADIENTS[idx].to}
            />
          )}
          <StepCircle stroke={COLOR_GRADIENTS[idx].stroke} />
          <div>
            <div className="text-lg font-semibold leading-7 tracking-[-0.256px] text-[#BEC2CC] md:text-xl md:leading-7 md:tracking-[-0.336px]">{`STEP ${idx + 1}`}</div>
            <div className="mb-[32px] text-sm font-semibold leading-[22px] tracking-[-0.128px] text-[#2B2E33] md:text-base md:leading-[26px] md:tracking-[-0.176px]">
              {label}
            </div>
          </div>
        </li>
      ))}
    </ul>
  );
}

export default Stepper;

export function StepCircle({
  stroke,
  fill = 'white',
}: {
  stroke?: string;
  fill?: string;
}) {
  return (
    <div className="flex h-[full] min-w-[24px] max-w-[25px] self-start pt-[2px]">
      <svg
        width="24"
        height="25"
        viewBox="0 0 24 25"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle
          cx="12"
          cy="12.5"
          r="9"
          fill={fill}
          stroke={stroke}
          strokeWidth="6"
        />
      </svg>
    </div>
  );
}

interface StepLineProps {
  from: string;
  to: string;
}

export function StepLine({ from, to }: StepLineProps) {
  const baseClassName =
    'absolute left-[11px] top-[4px] h-full w-0.5 bg-gradient-to-b z-[-1]';

  return <div className={cn(baseClassName, from, to)} />;
}
